import { buildPath, buildTemplatePath, Page, PageRoute } from "@compass/core";
import { TestDevExpressReportPerformance } from "./TestDevExpressReportPerformance/TestDevExpressReportPerformance";
import { TestDevExpressReportGroupings } from "./TestDevExpressReportGroupings/TestDevExpressReportGroupings";
import { TestNestedModelProperties } from "./TestNestedModelProperties/TestNestedModelProperties";
import { TestDevExpressReportSort } from "./TestDevExpressReportSort/TestDevExpressReportSort";
import { TestRenderComponents } from "./TestRenderComponents/TestRenderComponents";
import { TestEditableList } from "./TestEditableList/TestEditableList";
import { TestEllipsis } from "./TestEllipsis/TestEllipsis";
import { TestTComponent } from "./TestTComponent/TestTComponent";
import { TestConditionalGeneric } from "./TestConditionalGeneric/TestConditionalGeneric";
import { TestUseCallback } from "./TestUseCallback/TestCallbackRef";
import { TestListMemo } from "./TestListMemo/TestListMemo";
import { TestResponsiveHeader } from "./TestResponsiveHeader/TestResponsiveHeader";
import { TestFlexbox } from "./TestFlexbox/TestFlexbox";
import { TestPromises } from "./TestPromises/TestPromises";
import { TestBreakpointSizes } from "./TestBreakpointSizes/TestBreakpointSizes";
import { TestPendingChanges } from "./TestPendingChanges/TestPendingChanges";

const routeName = "test";

export const testPageRoute: PageRoute = {
  handle: "Test",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const TestPage = () => {
  return (
    <Page>
      <TestPendingChanges />
      {/* <TestBreakpointSizes /> */}
      {/* <TestPromises /> */}
      {/* <TestFlexbox /> */}
      {/* <TestResponsiveHeader /> */}
      {/* <TestUseCallback /> */}
      {/* <TestListMemo /> */}
      {/* <TestConditionalGeneric /> */}
      {/* <TestTComponent /> */}
      {/* <TestEllipsis /> */}
      {/* <TestEditableList /> */}
      {/* <TestRenderComponents /> */}
      {/* <TestNestedModelProperties /> */}
      {/* <TestDevExpressReportSort /> */}
      {/* <TestDevExpressReportGroupings /> */}
      {/* <TestDevExpressReportPerformance /> */}
      {/* <TestRefThroughDialog /> */}
    </Page>
  );
};
